export type DefaultColumns = 'select' | 'actions';
